module.exports = __webpack_public_path__ + "assets/img/title-07b04352.png";